import { useMutation } from '@tanstack/react-query';
import { toast } from 'sonner';
import { useRefreshRelatedData } from '@/hooks/useRefreshRelatedData';
import { showApiErrorToast } from '@/utils/errors';
import { assignInstitutes } from '../api/userInstituteMapping.api';
import type { AssignInstitutesPayload } from '../types/userInstituteMapping.types';

export function useAssignInstitutes(onSuccess?: () => void) {
  const refreshRelatedData = useRefreshRelatedData();

  return useMutation({
    mutationFn: (payload: AssignInstitutesPayload) => assignInstitutes(payload),
    onSuccess: (_data, variables) => {
      void refreshRelatedData('instituteMapping');
      const count = variables.instituteIds.length;
      toast.success(
        count === 1
          ? 'Institute assigned successfully'
          : `${count} institutes assigned successfully`,
      );
      onSuccess?.();
    },
    onError: (error) => {
      showApiErrorToast(error, 'Failed to assign institutes');
    },
  });
}
